import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import logo from './logo_cdap_1.png';
// import logo from '../../../public/logo/logo_cdap_1.png'
const Logo = ({ at, width, className, textClass, ...rest }) => {
  return (
    <Link
      to="/"
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex align-items-center',
          {
            'py-3': at === 'navbar-vertical',
            'flex-center fw-bolder fs-5 mb-4': at === 'auth'
          },
          className
        )}
      >
    
        <img
  className="me-2"
  src={logo}
  alt="CDAP Logo"
  
  style={{ height: '2.2em', width: 'auto'  }}
/>

        <span className={classNames('font-sans-serif', 'text-white', 'f-20', textClass)}>
          City Data and Analytics Platform
        </span>
      </div>
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string,
  textClass: PropTypes.string
};

Logo.defaultProps = { at: 'auth', width: 90 };

export default Logo;